import { UserOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router';

import {
  BorderedSection,
  ComputerIcon,
  FactoryIcon,
  RecycleIcon,
  ShieldIcon,
  ThunderFilled,
} from '../../../../components';
import BlueLabel from '../../../../components/generic/BlueLabel';

const strategyComponentsOptions = [
  {
    icon: <ThunderFilled />,
    label: 'Facilities',
    slug: 'facilities',
  },
  {
    icon: <FactoryIcon fillColor="#437EF7" />,
    label: 'Production Equipment',
    slug: 'production',
  },
  {
    icon: <UserOutlined className="text-blue" />,
    label: 'People',
    slug: 'people',
  },
  {
    icon: <ComputerIcon fillColor="#437EF7" />,
    label: 'IT Resources',
    slug: 'it-resources',
  },
  {
    icon: <RecycleIcon fillColor="#437EF7" />,
    label: 'Supply Chain',
    slug: 'supply-chain',
  },
  {
    icon: <ShieldIcon fillColor="#437EF7" />,
    label: 'Other Considerations',
    slug: 'other-considerations',
  },
];

interface StrategyComponentsProps {
  locationName: string;
  processArea?: string;
  strategyID: string;
  replacementTime: string;
  strategyType?: 'processArea' | 'location';
}

const StrategyComponents = ({
  locationName,
  processArea,
  strategyID,
  replacementTime,
  strategyType = 'processArea',
}: StrategyComponentsProps) => {
  const navigate = useNavigate();

  const params = useParams();

  const { locationId, processAreaId } = params;

  const createStrategySlug = (path: string) => {
    if (strategyType === 'location') {
      return `/${path}/${locationId}/${strategyID}?locationName=${locationName}&strategyLength=${replacementTime}`;
    }

    return `/process-areas-and-strategies/${locationId}/${processAreaId}/${path}/${strategyID}?locationName=${locationName}&name=${processArea}&strategyLength=${replacementTime}`;
  };

  const handleNavigation = (resource: string) => {
    navigate(createStrategySlug(resource));
    window.scrollTo(0, 0);
  };

  return (
    <BorderedSection title="Strategy Components">
      <div className="flex flex-col gap-4">
        {strategyComponentsOptions?.map(({ icon: Icon, label, slug }) => (
          <BlueLabel
            key={slug}
            icon={Icon}
            label={label}
            onClick={() => handleNavigation(slug)}
          />
        ))}
      </div>
    </BorderedSection>
  );
};

export default StrategyComponents;
